// Legacy CheckoutProcessService entry point — kept ONLY for backwards compatibility.
import angular from 'angular';

// Re-export so existing imports keep working.
export { CheckoutProcessService } from '@ng/core/checkout-process/checkout-process.service';

/**
 * Empty AngularJS module — preserved so `acme.common.service.checkoutProcess`
 * keeps resolving. The actual factory is registered in ng-downgraded-components.ts.
 */
export const CheckoutProcessServiceModule = angular.module('acme.common.service.checkoutProcess', []).name;
